$(document).ready(function(){


    $('.landingform .submit').click(function(){
        var nom = $('#nom').val();
        var prenom = $('#prenom').val();
        var email = $('#mail').val();
        var error = 0;

        $('.landingform input.inpute').each(function(){
            var thisvalue = $(this).val();
            
            if( thisvalue == "" ){
                $(this).addClass('error');
                error = 1;
            }
        });

        if( !($('.landingform input[name=newsletters]').is(':checked')) ){
            error = 1;
            $('.landingform label.checkbox').addClass('error');
        }

        if(!error){
            ajouteLOptinDansLaBase(nom, prenom, email);
        }

    });

    $('.landingform input').keypress(function(){
        $(this).removeClass('error');
    });

    $(".landingform label.checkbox").click(function(){
        $(this).removeClass('error');
    });

    function ajouteLOptinDansLaBase(nom, prenom, email){

        $.ajax({
            url : '/wp-content/themes/index/ajax-landing.php',
            method : 'POST',
            data : {
                lenom : nom,
                leprenom : prenom,
                lemail : email
            },
            success : function(code_html, statut){
                $('.landingform_popin_bg').show();
            }
        });
    }

    $('.landingform_popin_bg').click(function(){
        $(this).hide();
    });

});